import { useState, useEffect } from 'react';
import {
    FormControl, MenuItem, Select, TextField, Card, Table, Stack, Button, TableBody, TableCell, Container, TableContainer, Modal, Box, TableRow, Typography, Divider, InputLabel
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import { BorderColorOutlined } from "@mui/icons-material";
import { toast } from 'react-toastify';
import Loader from 'src/components/Loader';
import { GetBannerListAction, ResetBannerListAction, UpdateBannerAction } from 'src/redux/actions/BannerManagementActive';
import "./BannerManagement.css"

export default function BannerManagement() {
    const dispatch = useDispatch();
    const bannerAPIData = useSelector(state => state.banner_manager.banner_list.data)
    const loadingSelector = useSelector(state => state.banner_manager.loading)
    const updateSelector = useSelector(state => state.banner_manager.banner_edit)
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [showeditModal, setShoweditModal] = useState(false);
    const [showeAddModal, setShowAddModal] = useState(false);
    const [uploadedImage, setUploadedImage] = useState(null)
    const [bannerModalData, setBannerModalData] = useState()
    const [state, setState] = useState({
        sequence: "",
        status: "",
        device: ""
    });

    useEffect(() => {
        dispatch(GetBannerListAction())
        return () => dispatch(ResetBannerListAction())
    }, [dispatch])

    useEffect(() => {
        if (Object.keys(updateSelector).length > 0) {
            if (updateSelector.data.status) {
                toast.success(updateSelector.data.message, { theme: "colored" })
                setShoweditModal(false)
                setTimeout(() => {
                    dispatch(GetBannerListAction())
                    window.location.reload();
                }, 1000);
            } else {
                toast.error(updateSelector.data.message, { theme: "colored" })
            }
        }
    }, [updateSelector])

    const handleEditCloseModal = () => {
        setShoweditModal(false)
        setBannerModalData("")
        setState({
            sequence: "",
            status: "",
            device: "",
            banner_link: ""
        });
    }

    const handleAddCloseModal = () => {
        setShowAddModal(false)
        setBannerModalData("")
        setState({
            sequence: "",
            status: "",
            device: "",
            banner_link: "",

        });
    }

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleEdit = (data) => {
        console.log("data-->>", data)
        //state[key] = value;
        setState(data);
        setShoweditModal(true)
        setBannerModalData(data)
    }

    const handleAdd = (data) => {
        setShowAddModal(true)
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "30%",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    const handleFileChange = (e) => {
        const { files } = e.target
        if (files?.length > 0) {
            const { name, type } = files[0];
            const params = {
                key: name.includes('.') ? name.substring(0, name.indexOf('.')) : name,
                extension: type.includes('/') ? type.substring(type.indexOf('/') + 1) : type
            };

            if (
                params.extension.toLowerCase() === "jpg" ||
                params.extension.toLowerCase() === "jpeg" ||
                params.extension.toLowerCase() === "png"
            ) {
                if (files) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        document.getElementById('bannerImage').src = e.target.result;
                    };
                    reader.readAsDataURL(e.target.files[0]);
                    setUploadedImage(e.target.files[0])
                }
                toast.success('Image Uploaded Successfully', { theme: "colored" });
            } else {
                toast.error("Only image with .jpeg, .jpg, .png extentions are valid.");
            }
        }
    }

    const handleEditSubmit = () => {
        console.log("bannerModalData--->>", state);
        let formData = new FormData();
        formData.append("type", state.type);
        formData.append("banner_id", state._id);
        if (state.sequence) {
            formData.append("sequence", state.sequence);
        }
        if (uploadedImage) {
            formData.append("image", uploadedImage);
        }
        if (state.status) {
            formData.append("status", state.status);
        }
        if (state.device) {
            formData.append("device", state.device);
        }
        if (state.device) {
            formData.append("banner_link", state.banner_link);
        }
        dispatch(UpdateBannerAction(formData))
    }

    const stateChangeHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    console.log("state--->>", state)

    return (
        <Page title="Cricket Teams Manager">
            {loadingSelector ? <Loader /> : null}

            <Modal
                open={showeditModal}
                onClose={handleEditCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        Edit
                    </Typography>
                    <Divider />
                    <br />
                    <Stack container spacing={3}>

                        <FormControl fullWidth>

                            <TextField
                                onChange={({ target }) => stateChangeHandler("banner_link", target.value)}
                                type="text"
                                variant="outlined"
                                label="Banner Link"
                                value={bannerModalData?.banner_link}
                                fullWidth
                                required
                            />
                        </FormControl>



                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Banner Sequence *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                onChange={({ target }) => stateChangeHandler("sequence", target.value)}
                                id="demo-simple-select"
                                label="Select Banner Sequence"
                                defaultValue={bannerModalData?.sequence}
                            >
                                <MenuItem value="1"> 1 </MenuItem>
                                <MenuItem value="2"> 2 </MenuItem>
                                <MenuItem value="3"> 3 </MenuItem>
                                <MenuItem value="4"> 4 </MenuItem>
                                <MenuItem value="5"> 5 </MenuItem>
                                <MenuItem value="6"> 6 </MenuItem>
                                <MenuItem value="7"> 7 </MenuItem>
                                <MenuItem value="8"> 8 </MenuItem>
                                <MenuItem value="9"> 9 </MenuItem>
                                <MenuItem value="10"> 10 </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Status *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                onChange={({ target }) => stateChangeHandler("status", target.value)}
                                id="demo-simple-select"
                                label="Select Status"
                                defaultValue={bannerModalData?.status}
                            >
                                <MenuItem value="1"> Active </MenuItem>
                                <MenuItem value="2"> Inactive </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <input
                                required
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e)}
                                style={{ width: "100%", fontSize: 16 }}
                                name="image"
                            />
                            {uploadedImage ?
                                <img src="" id="bannerImage" className="img-fluid" height="150" style={{ marginTop: 10 }} alt="" />
                                : null
                            }
                            {bannerModalData && !uploadedImage ?
                                <img src={bannerModalData.image} className="img-fluid" height="150" style={{ marginTop: 10 }} alt="" />
                                : null
                            }
                        </FormControl>
                    </Stack>

                    <Button
                        align={"center"}
                        style={{ marginTop: 20, width: "100%" }}
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={(e) => handleEditSubmit(e)}
                    >
                        Submit
                    </Button>
                </Box>
            </Modal>

            <Modal
                open={showeAddModal}
                onClose={handleAddCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll", maxHeight: "100vh" }}
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        Add
                    </Typography>
                    <Divider />
                    <br />
                    <Stack container spacing={3}>

                        <FormControl fullWidth>

                            <TextField
                                onChange={({ target }) => stateChangeHandler("banner_link", target.value)}
                                type="text"
                                variant="outlined"
                                label="Banner Link"
                                value={bannerModalData?.banner_link}
                                fullWidth
                                required
                            />
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Game *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                onChange={({ target }) => stateChangeHandler("type", target.value)}
                                id="demo-simple-select"
                                label="Select Banner Sequence"
                                defaultValue={bannerModalData?.type}
                            >
                                <MenuItem value="ckt"> Cricket </MenuItem>
                                <MenuItem value="fb"> Football </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Banner Sequence *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                onChange={({ target }) => stateChangeHandler("sequence", target.value)}
                                id="demo-simple-select"
                                label="Select Banner Sequence"
                                defaultValue={bannerModalData?.sequence}
                            >
                                <MenuItem value="1"> 1 </MenuItem>
                                <MenuItem value="2"> 2 </MenuItem>
                                <MenuItem value="3"> 3 </MenuItem>
                                <MenuItem value="4"> 4 </MenuItem>
                                <MenuItem value="5"> 5 </MenuItem>
                                <MenuItem value="6"> 6 </MenuItem>
                                <MenuItem value="7"> 7 </MenuItem>
                                <MenuItem value="8"> 8 </MenuItem>
                                <MenuItem value="9"> 9 </MenuItem>
                                <MenuItem value="10"> 10 </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Status *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                onChange={({ target }) => stateChangeHandler("status", target.value)}
                                id="demo-simple-select"
                                label="Select Status"
                                defaultValue={bannerModalData?.status}
                            >
                                <MenuItem value="1"> Active </MenuItem>
                                <MenuItem value="2"> Inactive </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Device *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                onChange={({ target }) => stateChangeHandler("device", target.value)}
                                id="demo-simple-select"
                                label="Select Device"
                                defaultValue={bannerModalData?.device}
                            >
                                <MenuItem value="web"> Web </MenuItem>
                                <MenuItem value="mobile"> Mobile </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <input
                                required
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e)}
                                style={{ width: "100%", fontSize: 16 }}
                                name="image"
                            />
                            {uploadedImage ?
                                <img src="" id="bannerImage" className="img-fluid" height="150" style={{ marginTop: 10 }} alt="" />
                                : null
                            }
                            {bannerModalData && !uploadedImage ?
                                <img src={bannerModalData.image} className="img-fluid" height="150" style={{ marginTop: 10 }} alt="" />
                                : null
                            }
                        </FormControl>
                    </Stack>

                    <Button
                        align={"center"}
                        style={{ marginTop: 20, width: "100%" }}
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={(e) => handleEditSubmit(e)}
                    >
                        Submit
                    </Button>
                </Box>
            </Modal>

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Banner Management"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Banner Management' }
                    ]}
                    action={
                        <Button
                            variant="contained"
                            onClick={() => handleAdd()}
                        >
                            Add
                        </Button>
                    }
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'image', label: 'Banner Image', alignRight: false },
                                        { id: 'type', label: 'Type', alignRight: false },
                                        { id: 'device', label: 'Device', alignRight: false },
                                        { id: 'sequence', label: 'Sequence', alignRight: false },
                                        { id: 'status', label: 'Status', alignRight: false },
                                        { id: 'banner_link', label: 'Banner Link', alignRight: false },
                                        { id: 'action', label: 'Action', alignRight: true }
                                    ]}
                                // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {bannerAPIData && bannerAPIData.data.banner_list.map((value, index) => {
                                        return (
                                            <TableRow hover key={index}>
                                                <TableCell component="th" scope="row">
                                                    {index + 1}.
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <img src={value.image ? value.image : '/static/no_image.png'} width="150" className='img-fluid' alt='' />
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {value.type ?
                                                        value.type === "fb" ?
                                                            "Football"
                                                            :
                                                            "Cricket"
                                                        :
                                                        "-"
                                                    }
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {value.device}
                                                </TableCell>
                                                <TableCell component="th" scope="row">{value.sequence ? value.sequence : "-"}</TableCell>
                                                <TableCell component="th" scope="row">
                                                    {value.status === 1 ?
                                                        <span className='badge badge-small badge-success'>active</span>
                                                        :
                                                        <span className='badge badge-small badge-error'>deactive</span>
                                                    }
                                                </TableCell>

                                                <TableCell component="th" scope="row">
                                                    {value.banner_link}
                                                </TableCell>

                                                <TableCell component="th" scope="row" align='right'>
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleEdit(value)}
                                                    >
                                                        <BorderColorOutlined />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>
        </Page>
    );
}
